let LoginStatus = false //登录状态
let ShowSubContainer = false //个人中心切换子栏目状态
let showPay = false //调用
let orderId = null
try {
    //待弃用 为保证用户数据 停止使用localStorage缓存用户数据
    if(localStorage.LoginStatus) {
        LoginStatus = localStorage.LoginStatus
    }

} catch (err) {
    alert(err)
}

export default {
    LoginStatus,
    ShowSubContainer,
    showPay,
    orderId
}


// WEBPACK FOOTER //
// ./src/store/state.js